import { Box } from "@mui/material";
import WorkspaceTable from "../../component/common/WorkspaceTable";
import { Fragment } from "react";

export default function WorkSpaces(props) {
 
  //   const classes = DatasetStyle();
  //   const dispatch = useDispatch();
  //   const workspaceData = useSelector(state=>state.getWorkspaces.data);

  //   const getDashboardWorkspaceData = ()=>{
  //   const workspaceObj = new GetWorkspacesAPI(1);
  //   dispatch(APITransport(workspaceObj));
  // }
  
  // useEffect(()=>{
  //   getDashboardWorkspaceData();
  // },[]);
    

  return (
    <Fragment>
    {/* <Header /> */}
    <Box sx={{ margin : "0 auto", pb : 5 }}>
        {/* <Typography variant="h5" sx={{mt : 2, mb : 2}}>Visit Workspaces</Typography> */}
        <WorkspaceTable 
          showManager={false} 
          showCreatedBy={false} 
          // workspaceData={workspaceData} 
        />
    </Box>
</Fragment>
  )
}
